import { h, Host } from "@stencil/core";
import { scrollToTarget } from "../../../utils/scrollToTarget";
import { elementsSelectors } from "../supported-elements-selectors";
/**
 * @slot (default) - insert the content of the various form steps, each wrapped
 * in a ux-form-step element
 */
export class MultipleStepForm {
    baseClass = "ux-form-steps";
    tabContainer;
    uxFormElement;
    element;
    nextStepButton = "data-ux-form-steps-next";
    previousStepButton = "data-ux-form-steps-prev";
    connectedCallback() {
        // @ts-expect-error Check for typing
        this.uxFormElement = this.element.closest("ux-form");
    }
    async handleButtonClicks(e) {
        const eTarget = e.target;
        const activeTab = this.element.querySelector("ux-tab.is-active");
        if (!this.element.contains(eTarget)) {
            return;
        }
        if (eTarget.hasAttribute(this.nextStepButton)) {
            await this.validateFormStep(activeTab);
            setTimeout(async () => {
                const isActiveStepValid = this.isFormStepValid(activeTab);
                if (isActiveStepValid) {
                    await this.goToNextStep(activeTab);
                    scrollToTarget({
                        target: this.element,
                        additionalOffsetTop: 30
                    });
                }
            }, 100);
        }
        else if (eTarget.hasAttribute(this.previousStepButton)) {
            await this.goToPreviousStep(activeTab);
            scrollToTarget({
                target: this.element,
                additionalOffsetTop: 30
            });
        }
    }
    goToNextStep = async (activeTab) => {
        const activeTabStep = activeTab.closest("ux-form-step");
        const nextTabStep = activeTabStep?.nextElementSibling?.querySelector("ux-tab");
        if (!nextTabStep) {
            return;
        }
        // @ts-expect-error Check for typing
        await this.tabContainer.setActiveTab(nextTabStep.getAttribute("tab-id"));
    };
    goToPreviousStep = async (activeTab) => {
        const activeTabStep = activeTab.closest("ux-form-step");
        const prevTabStep = activeTabStep?.previousElementSibling?.querySelector("ux-tab");
        if (!prevTabStep) {
            return;
        }
        // @ts-expect-error Check for typing
        await this.tabContainer.setActiveTab(prevTabStep.getAttribute("tab-id"));
    };
    validateFormStep = async (activeStep) => {
        await this.uxFormElement.validateElements(activeStep);
    };
    isFormStepValid = (activeStep) => {
        const formElements = Array.from(activeStep.querySelectorAll(elementsSelectors.join(", ")));
        let isValid = true;
        // @ts-expect-error Check for typing
        formElements.forEach((formElement) => {
            if (formElement.error) {
                isValid = false;
            }
        });
        return isValid;
    };
    render() {
        return (h(Host, { key: '2b9f392d97dbbacfbc4c3d59cf641a55e7605cd5', class: this.baseClass }, h("ux-tab-container", { key: 'ab2d474f5565daf8ea4f410bc1223f010bba4071', ref: (el) => (this.tabContainer = el), "no-navigation": true }, h("slot", { key: 'a5d793279241ce418a41aa48c43c001178715005' }))));
    }
    static get is() { return "ux-form-steps"; }
    static get elementRef() { return "element"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "handleButtonClicks",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=form-steps.js.map
